import { render, staticRenderFns } from "./SparsEquipments.vue?vue&type=template&id=087d7020"
import script from "./SparsEquipments.vue?vue&type=script&lang=js"
export * from "./SparsEquipments.vue?vue&type=script&lang=js"
import style0 from "./SparsEquipments.vue?vue&type=style&index=0&id=087d7020&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports